import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  debounceTime,
  map,
  skip,
  switchMap,
  takeUntil,
} from 'rxjs/operators';
import { asyncScheduler, of } from 'rxjs';

import * as HardwareActions from '@fc-store/actions/hardware.actions';
import { HardwareApiService } from '@fc-core';

@Injectable()
export class HardwareEffects {
  searchHardware$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HardwareActions.searchHardware),
      debounceTime(300, asyncScheduler),

      switchMap(({ search, assigned = false, vehicleId }) => {
        const nextSearch$ = this.actions$.pipe(
          ofType(HardwareActions.searchHardware),
          skip(1),
        );

        return this.hardwareApiService.search(search, assigned, vehicleId).pipe(
          takeUntil(nextSearch$),
          map((data: any) => HardwareActions.searchHardwaresSuccess({ data })),
          catchError((error) =>
            of(HardwareActions.searchHardwaresFailure({ error })),
          ),
        );
      }),
    ),
  );

  getAllHardware$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HardwareActions.getAllHardware),
      switchMap(() => {
        return this.hardwareApiService.loadAll().pipe(
          map((data: any) => HardwareActions.getAllHardwareSuccess({ data })),
          catchError((error) =>
            of(HardwareActions.searchHardwaresFailure({ error })),
          ),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private hardwareApiService: HardwareApiService,
  ) {}
}
